import { SubAPI } from "./SubAPI";
export class Submissions extends SubAPI {
    list(props) { return this.fetcher.get("/api/submissions", props); }
    setSubmitted(input) { return this.fetcher.post("/api/submission/set-submitted", input); }
    download(id) { const c = new URLSearchParams(); c.set("id", id.toString()); window.open("/api/submission/download?" + c.toString(), "_blank"); }
    setPreferences(props) { return this.fetcher.post("/api/submission/preferences", props); }
    getPreferences(props) { return this.fetcher.get("/api/submission/preferences", props); }
}
